import {DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData} from '@angular/common';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import localeFrBe from '@angular/common/locales/fr-BE';
import localeFrNl from '@angular/common/locales/nl-BE';
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection
} from '@angular/core';
import {provideLuxonDateAdapter} from "@angular/material-luxon-adapter";
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {TranslateCompiler, TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader} from "@ngx-translate/http-loader";
import {provideOAuthClient} from 'angular-oauth2-oidc';
import {Settings} from "luxon";
import {provideEnvironmentNgxMask} from "ngx-mask";
import {ApiConfiguration} from "../api/api-configuration";
import {environment} from "../environments/environment";
import {routes} from './app.routes';
import {LoadingAndErrorInterceptor} from "./loading/loading-and-error-interceptor.service";
import {TranslateMessageFormatCompiler} from "ngx-translate-messageformat-compiler";


// Luxon configuration
Settings.defaultZone = "Europe/Brussels";
registerLocaleData(localeFrBe);
registerLocaleData(localeFrNl);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-BE' },
    provideRouter(routes, withComponentInputBinding()),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.apiUrl],
        sendAccessToken: true
      }
    }),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        compiler: {
          provide: TranslateCompiler,
          useClass: TranslateMessageFormatCompiler,

        },
        loader: {
          provide: TranslateLoader,
          useFactory: () => new TranslateHttpLoader()
        }
      })
    ),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json'
      }
    },
    provideLuxonDateAdapter(),
    provideAnimationsAsync(),
    provideEnvironmentNgxMask(),
    {
      provide: ApiConfiguration,
      useFactory: () => configureApiService(),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingAndErrorInterceptor,
      multi: true,
    },
    {provide: MAT_DATE_LOCALE, useValue: 'fr-BE'},
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
    {provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: {dateFormat: 'dd/MM/yyyy'}},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 5000}},
    provideZoneChangeDetection()
  ]
};

function configureApiService() {
  const apiConfiguration = new ApiConfiguration();
  apiConfiguration.rootUrl = environment.apiUrl;
  return apiConfiguration;
}
